import { getWirkUrl } from '@definitions/wirk-urls'
import { rootUrl } from '@navigation/route-declarations'

export const oidcAuthority = `${getWirkUrl('IdentityServer')}`
export const oidcClientId = 'worker'
export const oidcRedirectUri = `${window.location.origin}/${rootUrl.navigate()}`
//dynamic tenant name passed in the url
export const acrValues = `tenant:${rootUrl.navigate()}`
